angular.module("ainapp")
    .controller("employeeWisePosReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Employee Wise POS Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {

                var startdate = new Date(new Date().getFullYear(), 0, 1);

                $scope.filter = {
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                    EmployeeIds: [],
                }
            }
            $scope.Init();


            $scope.employeeSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.EmployeesInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectEmployeeOptions = {
                placeholder: "Select Employees...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.employeeSelectDataSource
            };




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromDate = $scope.filter.FromDate;
                        o.data.ToDate = $scope.filter.ToDate;
                        o.data.BranchId = $scope.filter.BranchId;
                        o.data.EmployeeIds = $scope.filter.EmployeeIds;

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        MainService.EmployeeCounterSalesInReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },

                            BillNo: {
                                type: "string",
                            },

                            PayType: {
                                type: "string",
                            },

                            "AccountMaster.Name": {
                                type: "string",
                            },
                            "User.UserName": {
                                type: "string",
                            },

                            SubTotal: {
                                type: "number",
                            },
                            Taxable: {
                                type: "number",
                            },
                            TotalQuantity: {
                                type: "number",
                            },
                            TotalDiscount: {
                                type: "number",
                            },
                            TotalVAT: {
                                type: "number",
                            },
                            GrandTotal: {
                                type: "number",
                            },
                            IsPaymentDone: {
                                type: "boolean",
                            },
                            "Branch.Name": {
                                type: "string",
                            },
                            "Employee.Name": {
                                type: "string",
                            },
                            "Warehouse.Name": {
                                type: "string",
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "Employee.Name",
                    aggregates: [{
                            field: "TotalQuantity",
                            aggregate: "sum"
                    },
                        {
                            field: "TotalDiscount",
                            aggregate: "sum"
                        }, {
                            field: "SubTotal",
                            aggregate: "sum"
                        },
                        {
                            field: "Taxable",
                            aggregate: "sum"
                        },
                        {
                            field: "TotalVAT",
                            aggregate: "sum"
                        },
                        {
                            field: "GrandTotal",
                            aggregate: "sum"
                        }]
                }],
                aggregate: [{
                        field: "TotalQuantity",
                        aggregate: "sum"
                    },
                    {
                        field: "TotalDiscount",
                        aggregate: "sum"
                        }, {
                        field: "SubTotal",
                        aggregate: "sum"
                        },
                    {
                        field: "Taxable",
                        aggregate: "sum"
                        },
                    {
                        field: "TotalVAT",
                        aggregate: "sum"
                        },
                    {
                        field: "GrandTotal",
                        aggregate: "sum"
                        }],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "BillNo",
                        title: "Bill No",
                                            },
                    {
                        field: "AccountMaster.Name",
                        title: "Customer",
                                            },
                    {
                        field: "Branch.Name",
                        title: "Branch",
                                            },

                    {
                        field: "User.UserName",
                        title: "Created By",
                                            },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                                            },
                    {
                        field: "PayType",
                        title: "Pay Type",
                                            },
                    {
                        field: "TotalQuantity",
                        title: "Total Qty",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },
                    {
                        field: "SubTotal",
                        title: "Sub Total",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },
                    {
                        field: "TotalDiscount",
                        title: "Total Discount",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },
                    {
                        field: "Taxable",
                        title: "Taxable",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },
                    {
                        field: "TotalVAT",
                        title: "Total VAT",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",

                                            },

                    {
                        field: "IsPaymentDone",
                        title: "Payment Done?",
                        template: "<p ng-if='dataItem.IsPaymentDone'>Yes</p> <p ng-if='!dataItem.IsPaymentDone'>No</p>"
                                            },
                    {
                        field: "Warehouse.Name",
                        title: "Warehouse",
                                            },

                    ],
            };

            $scope.filterData = function () {
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



        }])
